<template>
  <el-row>
    <el-col :span="24">
      <el-card class="data">
        <div class="data-title flex-space-between" slot="header">
          <p>Claims</p>
          <div class="float-right">
            <Filters />
            <el-tooltip content="Release all claims" placement="top">
              <el-button
                type="success"
                circle
                icon="el-icon-check"
                @click.prevent="releaseAll()"
                class="ml10"
              ></el-button>
            </el-tooltip>
            <el-tooltip content="Confirm all claims" placement="top">
              <el-button
                type="danger"
                circle
                icon="el-icon-check"
                @click.prevent="confirmAll()"
                class="ml10"
              ></el-button>
            </el-tooltip>
            <el-tooltip content="Report" placement="top">
              <el-button
                  type="success"
                  circle
                  icon="el-icon-document"
                  @click="generateReport()"
                  class="ml10"
              ></el-button>
            </el-tooltip>
          </div>
        </div>
        <el-tabs type="border-card"  @tab-click="tabClick" v-model="tabs">
          <el-tab-pane label="Public" name="public">
            <ClaimsPublic />
          </el-tab-pane>
          <el-tab-pane label="Private" name="private">
            <ClaimsPrivate />
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Filters from '../components/youtube/claims/FiltersClaims'
import ClaimsPublic from '../components/youtube/claims/ClaimsPublic'
import ClaimsPrivate from '../components/youtube/claims/ClaimsPrivate'
import {mapState, mapActions, mapMutations} from 'vuex'

export default {
  components: {
    ClaimsPublic,
    ClaimsPrivate,
    Filters
  },

  data() {
    return {
      tabs: 'public'
    }
  },

  computed: {
    ...mapState('youtubeClaims', ['loading', 'claimsPublic'])
  },

  methods: {
    ...mapActions('youtubeClaims', ['releaseAllClaims', 'confirmAllClaims', 'readClaims', 'readLabels', 'generateReport']),
    ...mapMutations('youtubeClaims', [
      'setPage',
      'setPageSize'
    ]),
    releaseAll() {
      this.releaseAllClaims()
    },
    confirmAll() {
      this.confirmAllClaims()
    },
    tabClick(tab){
      this.setPageSize(10)
      this.setPage(1)
      if(tab.name === 'public') {
        this.readClaims('Public')
      }
      else{
        this.readClaims('Private')
      }
    }
  }
}
</script>
